<div class="form-group form-group-col form-group-3-col form-control-f-w no-padding flexbox flex-wrap d-flex mb-0">
    <ng-template #monthForm>
        <lh-form-field layout="col" [labelText]="monthPlaceholder" [ngClass]="showMonthFirst ? 'col-4 pl-0' : 'col-4 px-0'">
            <input
                #month="ngModel"
                maxlength="2"
                minlength="1"
                name="month"
                pattern="^(0?[1-9]|1[012])$"
                ptNumberOnly
                type="tel"
                [attr.autocomplete]="autocomplete && 'bday-month'"
                [disabled]="isDisabled"
                [ngModel]="model.month"
                [required]="required"
                (blur)="onMonthChange($event)"
                (focus)="onFieldFocus()"
                (ngModelChange)="onModelChange($event, 'month')" />
        </lh-form-field>
    </ng-template>
    <ng-template #dayForm>
        <lh-form-field layout="col" [labelText]="dayPlaceholder" [ngClass]="!showMonthFirst ? 'col-4 pl-0' : 'col-4 px-0'">
            <input
                #day="ngModel"
                maxlength="2"
                minlength="1"
                name="day"
                pattern="[0-9]*"
                ptNumberOnly
                type="tel"
                [attr.autocomplete]="autocomplete && 'bday-day'"
                [disabled]="isDisabled"
                [ngModel]="model.day"
                [required]="required"
                (blur)="onDayChange($event)"
                (focus)="onFieldFocus()"
                (ngModelChange)="onModelChange($event, 'day')" />
        </lh-form-field>
    </ng-template>
    @if (showMonthFirst) {
        <ng-container *ngTemplateOutlet="monthForm"></ng-container>
    } @else {
        <ng-container *ngTemplateOutlet="dayForm"></ng-container>
    }
    @if (showMonthFirst) {
        <ng-container *ngTemplateOutlet="dayForm"></ng-container>
    } @else {
        <ng-container *ngTemplateOutlet="monthForm"></ng-container>
    }
    <lh-form-field class="col-4 pr-0" layout="col" [labelText]="yearPlaceholder">
        <input
            #year="ngModel"
            maxlength="4"
            minlength="4"
            name="year"
            pattern="[0-9]*"
            ptNumberOnly
            type="tel"
            [attr.autocomplete]="autocomplete && 'bday-year'"
            [disabled]="isDisabled"
            [ngModel]="model.year"
            [required]="required"
            (blur)="onYearChange($event)"
            (focus)="onFieldFocus()"
            (ngModelChange)="onModelChange($event, 'year')" />
    </lh-form-field>
</div>
